// extracted by mini-css-extract-plugin
module.exports = {"item":"cd01fbf7b5--item--wev3W","title":"cd01fbf7b5--title--gnIkq","content":"cd01fbf7b5--content--AKqsy","icon":"cd01fbf7b5--icon--HNp_U"};